import { RateProvider } from "./outbound-labels";

export const LINE_LENGTH_BY_PROVIDER: Record<RateProvider, number> = {
  [RateProvider.EASYPOST]: 35,
  [RateProvider.UPS]: 35,
  [RateProvider.LANDMARK_GLOBAL]: 30,
  [RateProvider.REDO_LANDMARK_GLOBAL]: 30,
  [RateProvider.INTERNATIONAL_BRIDGE]: 22,
  [RateProvider.ETA_EXPRESS]: 30,
  [RateProvider.SOAP_BOX]: 30,
  [RateProvider.TEST_CARRIER]: 30,
  [RateProvider.FEDEX]: 30,
  [RateProvider.USPS]: 30,
  [RateProvider.DHL_ECOMMERCE]: 30,
  [RateProvider.GLOBALE]: 30,
  [RateProvider.TIKTOK]: 30, // Tiktok doesn't support custom fields on their labels
  [RateProvider.CANADA_POST]: 30,
  [RateProvider.UNIUNI]: 25,
  [RateProvider.SENDCLOUD]: 30,
  [RateProvider.STALLION_EXPRESS]: 30,
};

export const MIN_PROVIDER_REFERENCE_LINE_LENGTH = Object.values(
  LINE_LENGTH_BY_PROVIDER,
).reduce((min, length) => Math.min(min, length), Infinity);

export function distributeAcrossLines(
  fields: string[],
  maxLineLength: number,
): string[] {
  const lines: string[] = [];
  let currentLine = "";

  for (const field of fields) {
    if (field.length > maxLineLength) {
      continue;
    }

    const separator = currentLine.length > 0 ? " " : "";
    const potentialLine = currentLine + separator + field;

    if (potentialLine.length <= maxLineLength) {
      currentLine = potentialLine;
    } else {
      if (currentLine.length > 0) {
        lines.push(currentLine.trim());
      }
      currentLine = field;
    }
  }

  if (currentLine.length > 0) {
    lines.push(currentLine.trim());
  }

  return lines;
}
